import moment from "moment";
import { reportG5 } from "./../services/reportG5.service";
import { Operator_service } from "../services/Operator_service";
import { Typegroup_service } from "../services/Typegroup.service";
import { MessageBox, Loading } from "element-ui";

const state = {
  provider_group : [],
  provider_list : [],
  showTable: "",
  text_label: "",
  month_th: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
  bar: null,
  data_of_dataset: [],
  data_bar: {
    labels: [],
    datasets: []
  },
  data_table: [],
  data_service_providers: [],
  proportion_second: 0,
  showDataNotFound: false
};
const actions = {
  
  async getGroupCompany({commit},type) {
    let obj = { provider_type : type}
    let result = await Typegroup_service.getGroupList(obj)
    if(result.status == 200){
      commit('PROVIDER_GROUP',result.data)
    } else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
      })
    }
  },

  async getProviderByType({commit},type){ 
    let result = await Operator_service.getProviderList(type)
    if (result.status == 200) {
      commit('PROVIDER_LIST',result.data)
    } else {
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
        confirmButtonText: 'ตกลง',
        showCancelButton: false,
        type: 'warning'
      })
    }
  },

  async resetTable({commit}){
    commit('RESET_TABLE');
  },

  async setData({commit},formdata) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let result = await reportG5.getAmountReport(formdata)
    let proportion_second = await reportG5.getServiceProportion()
    state.proportion_second = proportion_second.data[0].proportion_second
    if (result.status == 200) {
      if (result.data.result.length == 0) {
        state.showDataNotFound = true
        setTimeout(function(){ loadingInstance.close() }, 250);
      } else {
        state.showDataNotFound = false
        switch (formdata.type_report) {
          case 'month':
            let obj = {
              forminfo: formdata,
              qrydata: result.data.result
            }
            commit('MONTH',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
          case 'between_month':
            temp = moment(formdata.type_data.monthto).add(1,'M')._d
            obj = {
              date : {
                start : formdata.type_data.monthfrom,
                end : moment(temp).subtract(1,'seconds')._d
              },
              forminfo : formdata,
              qrydata : result.data
            }
            commit('BETWEEN_MONTH',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
          case 'year':
            let temp = moment(formdata.type_data.year,'YYYY-MM-DD').add(1,'Y')._d
            obj = {
              forminfo: formdata,
              qrydata: result.data.result,
              date: {
                start: moment(formdata.type_data.year,'YYYY-MM-DD')._d ,
                end: moment(temp).subtract(1,'seconds')._d
              }
            }
            commit('YEAR',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
          case 'between_year':
            temp = moment(formdata.type_data.yearto).add(1,'year')._d
            obj = {
              date: {
                start: formdata.type_data.yearfrom,
                end: moment(temp).subtract(1,'seconds')._d
              },
              forminfo: formdata,
              qrydata: result.data,
            }
            commit('BETWEEN_YEAR',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
          case 'quarter':
            obj = {
              date: {
                start: moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter - 1) * 3,'Month')._d,
                end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter * 3,'Month')._d
              },
              forminfo: formdata,
              qrydata: result.data,
            }
            commit('QUARTER', obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
          case 'between_quarter':
            obj = {
              date: {
                start: moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom - 1) * 3,'Month')._d,
                end: moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto * 3,'Month')._d
              },
              forminfo : formdata,
              qrydata : result.data,
            }
            commit('BETWEEN_QUARTER',obj)
            setTimeout(function(){ loadingInstance.close() }, 250);
            break;
        }
      }
    } else {
      setTimeout(function(){ loadingInstance.close() }, 250);
      MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
      })
    }
  }
};

const mutations = {

  PROVIDER_GROUP(state,data) {
    state.provider_group = data
  },

  PROVIDER_LIST(state,data) {
    state.provider_list = data
  },

  RESET_TABLE(state) {
    state.showTable = "";
  },

  MONTH(state,obj) {
    let data = obj.forminfo
    let providers = obj.forminfo.list
    let querydata = obj.qrydata
    state.text_label = "";
    let monthTh = state.month_th[moment(data.type_data.month).month()]
    let yearTh = moment(data.type_data.month).add(543,'y').year()
    let classify = data.type_data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย <br/> เดือน" + monthTh + " ปี พ.ศ. " + yearTh + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    if (data.type_data.classify == 1) {
      state.data_service_providers.push({
        colspan: 1,
        text:
          "เดือน" +
          state.month_th[moment(data.type_data.month).month()] +
          " ปี " +
          moment(data.type_data.month).add(543,'y').year()
      });
      for (let i = 0; i < providers.length; i++) {
        let provider_name = obj.forminfo.compare_type == 'group' ? providers[i].group_name_th : providers[i].brand_name
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(providers[i].group_company_list) : [providers[i].id]
        let rowdata = querydata.filter(item => provider_id.includes(item.provider_id))
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
        if (moment(data.type_data.month).year() < 2020) {
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        } else {
          for (let r = 0; r < rowdata.length; r++) {
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
        }
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0

        state.data_service_providers.push({
          colspan: 0,
          service_name: provider_name,
          amount_sec: total.second != 0 ? formatNumber(total.second) : '-',
          amount_min: total.minute != 0 ? formatNumber(total.minute) : '-',
          percent_sec: total.percent_second != 0 ? formatNumber(total.percent_second) : '-',
          percent_min: total.percent_minute != 0 ? formatNumber(total.percent_minute) : '-',
        });
      }
      state.showTable = false;
    } else {
      state.data_table = [];
      state.data_table.push({
        colspan: 1,
        text:
          "เดือน" +
          state.month_th[moment(data.type_data.month).month()] +
          " ปี " +
          moment(data.type_data.month).add(543,'y').year()
      });
      let rowdata = querydata.filter(item => item.provider_id)
      total.amount = 0
      
      if(moment(data.type_data.month).year() < 2020){
        for(let r = 0; r < rowdata.length; r++){
          total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
          total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
        }
      } else {
        for(let r = 0; r < rowdata.length; r++){
          if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
            total.minute += rowdata[r].total
          } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
            total.second += rowdata[r].total
          }
        }
      }
        
      total.amount = total.minute + total.second
      total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
      total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
      if(isNaN(total.percent_minute)) total.percent_minute = 0
      if(isNaN(total.percent_second)) total.percent_second = 0
      state.data_table.push({
        colspan: 0,
        text: "",
        rank: 1,
        month: state.month_th[moment(data.type_data.month).month()],
        v_point: formatNumber(total.second),
        v_per: total.percent_second,
        min_point: formatNumber(total.minute),
        min_per: total.percent_minute,
        all_point: formatNumber(total.amount),
        all_per: total.percent_amount,
      }); 
      state.showTable = true;
    }
  },

  BETWEEN_MONTH(state,obj){
    let data = obj.forminfo
    let querydata = obj.qrydata.result
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    state.text_label = ""
    let month_from = state.month_th[moment(data.type_data.monthfrom).month()]
    let month_to = state.month_th[moment(data.type_data.monthto).month()]
    let year_from = moment(data.type_data.monthfrom).add(543,'y').year()
    let year_to = moment(data.type_data.monthto).add(543,'y').year()
    let classify = data.type_data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย <br/> ระหว่างเดือน" + month_from + " ปี พ.ศ. " + year_from + " ถึงเดือน" + month_to + " ปี พ.ศ. " + year_to + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    let a = moment(new Date(data.type_data.monthfrom));
    let b = moment(new Date(data.type_data.monthto));
    let endMonth = b.diff(a, "months") + 1
    if (data.type_data.classify == 1) {
      let provider_list = obj.forminfo.list
      let curmonth = moment(data.type_data.monthfrom).format('YYYY-MM-DD')
      let monthly = parseInt(moment(data.type_data.monthfrom).format("M"))
      for (let startMonth = 0; startMonth < endMonth; startMonth++) {
        let year = moment(curmonth).year()
        state.data_service_providers.push({
          colspan: 1,
          text:
            "เดือน" +
            state.month_th[monthly-1] +
            " ปี " +
            (year + 543)
        });
        for (var j = 0; j < provider_list.length; j++) {
          let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[j].group_name_th : provider_list[j].brand_name
          let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[j].group_company_list) : [provider_list[j].id]
          let rowdata_group = querydata.filter(item => provider_id.includes(item.provider_id))
          let rowdata = rowdata_group.filter(item =>moment(item.monthly_regulate).format('YYYY-MM-DD') == moment(curmonth).format('YYYY-MM-DD'))
          if (year > 2019) {
            for(let r = 0; r < rowdata.length;r++){
              if(rowdata[r].service_charge_type.toLowerCase() == 'minute') {
                total.minute = rowdata[r].total
              } else if(rowdata[r].service_charge_type.toLowerCase() == 'second') {
                total.second = rowdata[r].total
              }
            }
          } else {
            for(let r = 0; r < rowdata.length; r++){
              total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
              total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
            }
          }
          total.amount = total.minute + total.second
          total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
          total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
          if(isNaN(total.percent_minute)) total.percent_minute = 0
          if(isNaN(total.percent_second)) total.percent_second = 0
          
          state.data_service_providers.push({
            colspan: 0,
            service_name: provider_name,
            amount_sec: total.second != 0 ? formatNumber(total.second) : '-',
            amount_min: total.minute != 0 ? formatNumber(total.minute) : '-',
            percent_sec: total.percent_second != 0 ? formatNumber(total.percent_second)  : '-',
            percent_min: total.percent_minute != 0 ? formatNumber(total.percent_minute)  : '-'
          });
          total = {
            percent_minute: 0,
            percent_second: 0,
            percent_amount: 100,
            amount: 0,
            minute: 0,
            second: 0,
          }
        }
        curmonth = moment(data.type_data.monthfrom).add(startMonth+1,'M').format("YYYY-MM-DD")
        monthly = parseInt(moment(data.type_data.monthfrom).add(startMonth+1,'M').format("M"))
      }
      state.showTable = false;
    } else {
      state.data_table = [];
      state.data_table.push({
        colspan: 1,
        text:
          "เดือน" +
          state.month_th[moment(data.type_data.monthfrom).month()] +
          " ปี " +
          moment(data.type_data.monthfrom).add(543,'y').year() +
          " ถึงเดือน" +
          state.month_th[moment(data.type_data.monthto).month()] +
          " ปี " +
          moment(data.type_data.monthto).add(543,'y').year()
      });
      let curmonth = moment(data.type_data.monthfrom).format("YYYY-MM-DD")
      let monthly = moment(curmonth).month()
      for (let startMonth = 0; startMonth < endMonth; startMonth++) {
        let rowdata = querydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
        let checkyear = moment(curmonth).year()
        if(checkyear > 2019){
          for(let r = 0; r < rowdata.length; r++){
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
        } else {
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        }
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0
        
        state.data_table.push({
          colspan: 0,
          text: "",
          rank: startMonth + 1,
          month: state.month_th[monthly],
          v_point: total.second != 0 ? formatNumber(total.second) : '-',
          v_per: total.percent_second != 0 ? total.percent_second : '-',
          min_point: total.minute != 0 ? formatNumber(total.minute) : '-',
          min_per: total.percent_minute != 0 ? total.percent_minute  : '-',
          all_point: total.amount != 0 ? formatNumber(total.amount)  : '-',
          all_per: total.percent_amount != 0 ? total.percent_amount  : '-',
        });
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
        curmonth = moment(data.type_data.monthfrom).add(startMonth+1,'M').format("YYYY-MM-DD")
        monthly = moment(curmonth).month()
      }
      state.showTable = true;
    }
  },

  YEAR(state,obj){
    let data = obj.forminfo.type_data
    let providers = obj.forminfo.list
    let querydata = obj.qrydata
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    let year_th = moment(new Date(data.year)).add(543,'y').year()
    state.text_label = ""
    let classify = data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย <br/> ปี พ.ศ. " + year_th + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    var count_rank = 0;
    if (data.classify == 1) {
      state.data_service_providers.push({
        colspan: 1,
        text: "ปี " + year_th
      });
      for(let i = 0; i < providers.length; i++){
        let provider_name = obj.forminfo.compare_type == 'group' ? providers[i].group_name_th : providers[i].brand_name
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(providers[i].group_company_list) : [providers[i].id]
        let rowdata = querydata.filter(item => provider_id.includes(item.provider_id))
        if(moment(data.year).year() < 2020){
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        } else {
          for(let r = 0; r < rowdata.length; r++){
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
          // if(rowdata[rowdata.length - 1].service_charge_type.toLowerCase() == 'minute'){
          //   total.minute += rowdata[rowdata.length - 1].total
          //   total.second += rowdata[rowdata.length - 2].total
          // } else if(rowdata[rowdata.length - 1].service_charge_type.toLowerCase() == 'second'){
          //   total.minute += rowdata[rowdata.length - 2].total
          //   total.second += rowdata[rowdata.length - 1].total
          // }
        }
        
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0
        state.data_service_providers.push({
          colspan: 0,
          service_name: provider_name,
          amount_sec: formatNumber(total.second) != 0 ? formatNumber(total.second) : '-',
          amount_min: formatNumber(total.minute) != 0 ? formatNumber(total.minute) : '-',
          percent_sec: formatNumber(total.percent_second) != 0 ? formatNumber(total.percent_second) : '-',
          percent_min: formatNumber(total.percent_minute) != 0 ? formatNumber(total.percent_minute) : '-',
        });
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
      }
      state.showTable = false;
    } else {
      state.bar ? state.bar.destroy() : "";
      state.data_table = [];
      state.data_table.push({
        colspan: 1,
        text: "ปี " + year_th
      });
      let curmonth = moment(new Date(data.year)).format("YYYY-MM-DD")
      for (let startMonth = 0; startMonth < 12; startMonth++) {
        let rowdata = querydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
        if(moment(data.year).year() < 2020){
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        } else {
          for(let r=0;r<rowdata.length;r++){
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
        }
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0
        
        state.data_table.push({
          colspan: 0,
          text: "",
          rank: count_rank + 1,
          month: state.month_th[parseInt(moment(new Date(data.year)).add(startMonth, "M").format("M") ) - 1 ],
          v_point: total.second != 0 ? formatNumber(total.second) : '-',
          v_per: total.percent_second != 0 ? total.percent_second : '-',
          min_point: total.minute != 0 ? formatNumber(total.minute) : '-',
          min_per: total.percent_minute != 0 ? total.percent_minute  : '-',
          all_point: total.amount != 0 ? formatNumber(total.amount)  : '-',
          all_per: total.percent_amount != 0 ? total.percent_amount  : '-',
        });
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
        count_rank++;
        curmonth = moment(data.year).add(startMonth+1,'M').format("YYYY-MM-DD")
      }
      state.showTable = true;
    }
  },

  BETWEEN_YEAR(state,obj){
    let data = obj.forminfo.type_data
    let querydata = obj.qrydata.result
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    state.text_label = "";
    let yearth_from = moment(data.yearfrom).add(543,'y').year()
    let yearth_to = moment(data.yearto).add(543,'y').year()
    let classify = data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย <br/> ระหว่างปี พ.ศ. " + yearth_from + " ถึงปี พ.ศ. " + yearth_to + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    let a = moment(new Date(data.yearfrom));
    let b = moment(new Date(data.yearto));
    let endYear = b.diff(a, "years") + 1;
    var count_rank = 0;
    if (data.classify == 1) {
      let provider_list = obj.forminfo.list
      let curYear = moment(data.yearfrom).year()
      for (let startYear = 0; startYear < endYear; startYear++) {
        state.data_service_providers.push({
          colspan: 1,
          text: "ปี " + moment(new Date(data.yearfrom)).add(startYear, "y").add(543,'y').year()
        });
        for (var j = 0; j < provider_list.length; j++) {
          let provider_name = obj.forminfo.compare_type == 'group' ? provider_list[j].group_name_th : provider_list[j].brand_name
          let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(provider_list[j].group_company_list) : [provider_list[j].id]
          let rowdata_group = querydata.filter(item => provider_id.includes(item.provider_id))
          let rowdata = rowdata_group.filter(item => moment(item.monthly_regulate).format('YYYY') == curYear)
          if(moment(curYear).year() < 2020){
            for(let r = 0; r < rowdata.length; r++){
              total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
              total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
            }
          } else {
            for(let r = 0; r < rowdata.length; r++){
              if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
                total.minute += rowdata[r].total
              } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
                total.second += rowdata[r].total
              }
            }
          }
          
          total.amount = total.minute + total.second
          total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
          total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
          if(isNaN(total.percent_minute)) total.percent_minute = 0
          if(isNaN(total.percent_second)) total.percent_second = 0
          state.data_service_providers.push({
            colspan: 0,
            service_name: provider_name,
            amount_sec: total.second != 0 ? formatNumber(total.second) : '-',
            amount_min: total.minute != 0 ? formatNumber(total.minute) : '-',
            percent_sec: total.percent_second != 0 ? formatNumber(total.percent_second) : '-',
            percent_min: total.percent_minute != 0 ? formatNumber(total.percent_minute) : '-',
          });
          total = {
            percent_minute: 0,
            percent_second: 0,
            percent_amount: 100,
            amount: 0,
            minute: 0,
            second: 0,
          }
        }
        curYear = moment(data.yearfrom).add(startYear+1,'years').format("YYYY")
      }
      state.showTable = false;
    } else {
      state.data_table = [];
      let curmonth = moment(new Date(data.yearfrom)).format("YYYY-MM-DD")
      for (let i = 0; i < endYear; i++) {
        let yearTh = moment(new Date(data.yearfrom)).add(i, "y").add(543,'y').year()
        state.data_table.push({
          colspan: 1,
          text: "ปี " + yearTh
        });
        for (let p = 0; p < 12; p++) {
          let rowdata = querydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
          
          if(yearTh > 2562){
            for(let r=0;r<rowdata.length;r++){
              if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
                total.minute += rowdata[r].total
              } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
                total.second += rowdata[r].total
              }
            }
          } else {
            for(let r = 0; r < rowdata.length; r++){
              total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
              total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
            }
          }
            
          total.amount = total.minute + total.second
          total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
          total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
          if(isNaN(total.percent_minute)) total.percent_minute = 0
          if(isNaN(total.percent_second)) total.percent_second = 0
          
          state.data_table.push({
            colspan: 0,
            text: "",
            rank: count_rank + 1,
            month: state.month_th[parseInt(moment(new Date(data.yearfrom)).add(p, "M").format("M")) - 1],
            v_point: total.second != 0 ? formatNumber(total.second) : '-',
            v_per: total.percent_second != 0 ? total.percent_second : '-',
            min_point: total.minute != 0 ? formatNumber(total.minute) : '-',
            min_per: total.percent_minute != 0 ? total.percent_minute  : '-',
            all_point: total.amount != 0 ? formatNumber(total.amount)  : '-',
            all_per: total.percent_amount != 0 ? total.percent_amount  : '-',
          });
          total = {
            percent_minute: 0,
            percent_second: 0,
            percent_amount: 100,
            amount: 0,
            minute: 0,
            second: 0,
          }
          count_rank++;
          curmonth = moment(data.yearfrom).add(p+1,'M').add(i,'years').format("YYYY-MM-DD")
        }
      }
      state.showTable = true;
    }
  },

  QUARTER(state,obj){
    let data = obj.forminfo.type_data
    let querydata = obj.qrydata.result
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    state.text_label = "";
    let quarter_yearth = moment(new Date(data.quarter_year)).add(543,'y').year()
    let classify = data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย<br/>ในไตรมาสที่ " + data.quarter + " ปี พ.ศ. " + quarter_yearth + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    var quarter = parseInt(data.quarter);
    if (data.classify == 1) {
      let providers = obj.forminfo.list
      state.data_service_providers.push({
        colspan: 1,
        text: "ไตรมาสที่ " + quarter + " ปี " + moment(new Date(data.quarter_year)).add(543,'y').year()
      });
      for(let i = 0; i < providers.length; i++){
        let provider_name = obj.forminfo.compare_type == 'group' ? providers[i].group_name_th : providers[i].brand_name
        let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(providers[i].group_company_list) : [providers[i].id]
        let rowdata = querydata.filter(item => provider_id.includes(item.provider_id))
        if(moment(data.quarter_year).year() < 2020){
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        } else {
          for(let r = 0; r < rowdata.length; r++){
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
        }
        
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0
        state.data_service_providers.push({
          colspan: 0,
          service_name: provider_name,
          amount_sec: total.second != 0 ? formatNumber(total.second) : '-',
          amount_min: total.minute != 0 ? formatNumber(total.minute) : '-',
          percent_sec: total.percent_second != 0 ? formatNumber(total.percent_second) : '-',
          percent_min: total.percent_minute != 0 ? formatNumber(total.percent_minute) : '-',
        });
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
      }
      state.showTable = false;
    } else {
      state.data_table = [];
      state.data_table.push({
        colspan: 1,
        text: "ไตรมาสที่ " + quarter + " ปี " + moment(new Date(data.quarter_year)).add(543,'y').year()
      });
      let startQuarter = 0,endQuarter = 0
      if(data.quarter == 1){startQuarter = 0, endQuarter = 3}
      else if(data.quarter == 2){startQuarter = 3, endQuarter = 6}
      else if(data.quarter == 3){startQuarter = 6, endQuarter = 9}
      else if(data.quarter == 4){startQuarter = 9, endQuarter = 12}
      let curmonth = moment(data.quarter_year).add(startQuarter,'M').format("YYYY-MM-DD")
      for (let startMonth = startQuarter; startMonth < endQuarter; startMonth++) {
        let rowdata = querydata.filter(item => moment(item.monthly_regulate).format('YYYY-MM-DD') == curmonth)
        if(moment(data.quarter_year).year() < 2020){
          for(let r = 0; r < rowdata.length; r++){
            total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
            total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
          }
        } else {
          for(let r=0;r<rowdata.length;r++){
            if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
              total.minute += rowdata[r].total
            } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
              total.second += rowdata[r].total
            }
          }
        }
        
        total.amount = total.minute + total.second
        total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
        total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
        if(isNaN(total.percent_minute)) total.percent_minute = 0
        if(isNaN(total.percent_second)) total.percent_second = 0
        
        state.data_table.push({
          colspan: 0,
          text: "",
          rank: startMonth + 1,
          month: state.month_th[parseInt(moment(new Date(data.quarter_year)).add(startMonth, "M").format("M")) - 1],
          v_point: total.second != 0 ? formatNumber(total.second) : '-',
          v_per: total.percent_second != 0 ? total.percent_second : '-',
          min_point: total.minute != 0 ? formatNumber(total.minute) : '-',
          min_per: total.percent_minute != 0 ? total.percent_minute  : '-',
          all_point: total.amount != 0 ? formatNumber(total.amount)  : '-',
          all_per: total.percent_amount != 0 ? total.percent_amount  : '-',
        });
        total = {
          percent_minute: 0,
          percent_second: 0,
          percent_amount: 100,
          amount: 0,
          minute: 0,
          second: 0,
        }
        curmonth = moment(data.quarter_year).add(startMonth+1,'M').format("YYYY-MM-DD")
      }
      state.showTable = true;
    }
  },

  BETWEEN_QUARTER(state,obj){
    let data = obj.forminfo.type_data
    let querydata = obj.qrydata.result
    let total = {
      percent_minute: 0,
      percent_second: 0,
      percent_amount: 100,
      amount: 0,
      minute: 0,
      second: 0,
    }
    state.text_label = "";
    let quarter_yearth_from = moment(new Date(data.quarter_year_from)).add(543,'y').format("YYYY")
    let quarter_yearth_to = moment(new Date(data.quarter_year)).add(543,'y').format("YYYY")
    let classify = data.classify == 1 ? ' จำแนกตามผู้ให้บริการ' : ' ไม่จำแนกตามผู้ให้บริการ'
    state.text_label = "ตารางแสดงจำนวนรายการส่งเสริมการขายและร้อยละของรายการส่งเสริมการขาย<br/>ในไตรมาสที่ " + data.quarterfrom + " ปี พ.ศ. " + quarter_yearth_from + " ถึงไตรมาสที่ " + data.quarterto + " ปี พ.ศ. " + quarter_yearth_to + classify
    state.data_service_providers = [];
    state.bar ? state.bar.destroy() : "";
    let start = moment(data.quarter_year_from).add((data.quarterfrom - 1) * 3,'M')._d
    let end = moment(data.quarter_year).add((data.quarterto) * 3,'M')
        end = moment(end).subtract(1,'seconds')._d
    if(data.classify == 1){
      let providers = obj.forminfo.list
      for(let date = moment(start); date <= moment(end); date = moment(date).add(3,'M')){
        let quarter_start = moment(date).subtract(1,'seconds')
        let quarter_end  = moment(date).add(3,'M')
            quarter_end = moment(quarter_end).subtract(1,'seconds')
        let quarter = (moment(date).format('M')-1)/3+1
        let year = moment(date).add(543,'y').format('YYYY')
        state.data_service_providers.push({
          colspan: 1,
          text: "ไตรมาสที่ " + quarter + " ปี " + year
        });
        
        for(let i = 0; i < providers.length; i++){
          let provider_name = obj.forminfo.compare_type == 'group' ? providers[i].group_name_th : providers[i].brand_name
          let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(providers[i].group_company_list) : [providers[i].id]
          let provider_data = querydata.filter(item => provider_id.includes(item.provider_id))
          let rowdata = provider_data.filter(item => moment(item.monthly_regulate).isBetween(quarter_start,quarter_end))
          if(year > 2562){
            for(let r = 0; r < rowdata.length; r++){
              if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
                // total.minute += rowdata[r].total
                total.minute = rowdata[r].total
              } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
                // total.second += rowdata[r].total
                total.second = rowdata[r].total
              }
            }
          } else {
            for(let r = 0; r < rowdata.length; r++){
              total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
              total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
            }
          }
          
          total.amount = total.minute + total.second
          total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
          total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
          if(isNaN(total.percent_minute)) total.percent_minute = 0
          if(isNaN(total.percent_second)) total.percent_second = 0

          state.data_service_providers.push({
            colspan: 0,
            service_name: provider_name,
            amount_sec: total.second != 0 ? formatNumber(total.second) : '-',
            amount_min: total.minute != 0 ? formatNumber(total.minute) : '-',
            percent_sec: total.percent_second != 0 ? formatNumber(total.percent_second)  : '-',
            percent_min: total.percent_minute != 0 ? formatNumber(total.percent_minute)  : '-'
          });
          total = {
            percent_minute: 0,
            percent_second: 0,
            percent_amount: 100,
            amount: 0,
            minute: 0,
            second: 0,
          }
        }
      }
      state.showTable = false;
    } else { // === NONE CLASSIFY ===
      state.data_table = [];
      let count_quarter = 1
      let current_year = moment(start).add(543, 'y').year()
      for(let date = moment(start); date <= moment(end); date = moment(date).add(3,'M')){
        let quarter_start = moment(date).subtract(1,'seconds')
        let quarter_end  = moment(date).add(3,'M')
            quarter_end = moment(quarter_end).subtract(1,'seconds')
        let quarter = (moment(date).format('M')-1)/3+1
        let year = moment(date).add(543,'y').format('YYYY')
        if(year != current_year){
          state.data_table.push({
            colspan: 1,
            text:
              " ปี " +
              year
          });
        }
        current_year = year
          let rowdata = querydata.filter(item => moment(item.monthly_regulate).isBetween(quarter_start,quarter_end))
          if(year > 2562 ){
            for(let r=0;r<rowdata.length;r++){
              if(rowdata[r].service_charge_type.toLowerCase() == 'minute'){
                total.minute += rowdata[r].total
              } else if(rowdata[r].service_charge_type.toLowerCase() == 'second'){
                total.second += rowdata[r].total
              }
            }
          } else {
            for(let r = 0; r < rowdata.length; r++){
              total.minute += rowdata[r].minute_amount != null ? rowdata[r].minute_amount : 0
              total.second += rowdata[r].second_amount != null ? rowdata[r].second_amount : 0
            }
          }
          total.amount = total.minute + total.second
          total.percent_minute = parseFloat(((total.minute * 100)/total.amount)).toFixed(2)
          total.percent_second = parseFloat(((total.second * 100)/total.amount)).toFixed(2)
          if(isNaN(total.percent_minute)) total.percent_minute = 0
          if(isNaN(total.percent_second)) total.percent_second = 0
              
          state.data_table.push({
            colspan: 0,
            text: "",
            rank: count_quarter,
            month: quarter+'Q'+year,
            v_point: total.second != 0 ? formatNumber(total.second) : '-',
            v_per: total.percent_second != 0 ? total.percent_second : '-',
            min_point: total.minute != 0 ? formatNumber(total.minute) : '-',
            min_per: total.percent_minute != 0 ? total.percent_minute  : '-',
            all_point: total.amount != 0 ? formatNumber(total.amount)  : '-',
            all_per: total.percent_amount != 0 ? total.percent_amount  : '-',
          });
          total = {
            percent_minute: 0,
            percent_second: 0,
            percent_amount: 100,
            amount: 0,
            minute: 0,
            second: 0,
          }
          count_quarter += 1 
      }
      state.showTable = true;
    }
  }
};

function formatNumber(num) {
  if (num >= 10) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else if( num < 1 ) {
    return num;
  }
  return num;
}

export const Report_G5 = {
  namespaced: true,
  state,
  actions,
  mutations
};
